import { createBrowserHistory as createHistory } from 'history';
var history = createHistory();
var parentPath = function (path) {
    return path
        .split('/')
        .slice(0, -1)
        .join('/');
};
export var toParentPath = function () {
    return history.replace(parentPath(history.location.pathname));
};
export default history;



//////////////////
// WEBPACK FOOTER
// ./src/helpers/History.ts
// module id = 14
// module chunks = 0